import React from 'react';
import moment from 'moment';

import FooterLessLayout from '../../components/Layout/FooterLessLayout';
import Search from './Search';
import fetch from '../../core/fetch';

import { searchListing } from '../../actions/searchListing';
import { setPersonalizedValues } from '../../actions/personalized';

import messages from '../../locale/messages';

const title = 'Search';

export default async function action({ params, store, query, intl, locale }) {

  const title = intl?.formatMessage(messages.search);
  // Fetch Search Settings
  const searchQuery = `
    {
      getSearchSettings {
        minPrice
        maxPrice
        priceRangeCurrency
      }
    }
  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: searchQuery,
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  // No longer reading from Redux store - URL is source of truth
  let personCapacity, dates, currentPage = 1, location, initialFilter = {};
  let fixedHeader = 'searchFixedHeader';
  
  // Check if URL has any search parameters
  const hasUrlParams = Object.keys(query).some(key => 
    ['address', 'guests', 'startdate', 'enddate'].includes(key) && query[key]
  );
  
  // If no URL params, clear all search state for "See All" behavior
  if (!hasUrlParams) {
    const stateToClear = ['location', 'chosen', 'personCapacity', 'startDate', 'endDate'];
    stateToClear.forEach(key => {
      store.dispatch(setPersonalizedValues({ name: key, value: null }));
    });
    // Set defaults for clean state
    location = null;
    personCapacity = null;
  } else {
    // URL params present - sync state with URL (URL as source of truth)
    
    // Location from URL
    if ("address" in query && query.address) {
      location = decodeURI(query.address);
      initialFilter["address"] = location;
      store.dispatch(setPersonalizedValues({ name: 'location', value: location }));
      store.dispatch(setPersonalizedValues({ name: 'chosen', value: 1 }));
    } else {
      location = null;
      store.dispatch(setPersonalizedValues({ name: 'location', value: null }));
    }

    // PersonCapacity from URL
    if ("guests" in query && query.guests) {
      initialFilter["personCapacity"] = Number(query.guests);
      personCapacity = Number(query.guests);
      store.dispatch(setPersonalizedValues({ name: 'personCapacity', value: personCapacity }));
    } else {
      personCapacity = null;
      store.dispatch(setPersonalizedValues({ name: 'personCapacity', value: null }));
    }
  }

  // Handle dates - URL params as source of truth  
  if ("startdate" in query && "enddate" in query && query?.startdate && query?.enddate) {
    // Validate dates
    let today = moment(new Date()).format("YYYY-MM-DD");
    let startDate = moment(query.startdate).format("YYYY-MM-DD");
    let endDate = moment(query.enddate).format("YYYY-MM-DD");
    let checkValidDate = false;
    
    if ((startDate < today) || endDate < today) {
      checkValidDate = true;
    } else if (startDate == endDate) {
      checkValidDate = true;
    } else if (startDate > endDate) {
      checkValidDate = true;
    } else if ((moment(startDate).isValid() == false) || (moment(endDate).isValid() == false)) {
      checkValidDate = true;
    }

    if (!checkValidDate) {
      // Valid dates - use them
      initialFilter["startDate"] = query?.startdate;
      initialFilter["endDate"] = query?.enddate;
      dates = `'${query?.startdate}' AND '${query?.enddate}'`;
      store.dispatch(setPersonalizedValues({ name: 'startDate', value: query?.startdate }));
      store.dispatch(setPersonalizedValues({ name: 'endDate', value: query?.enddate }));
      store.dispatch(setPersonalizedValues({ name: 'isOneTotalToggle', value: true }));
    } else {
      // Invalid dates - clear them
      dates = null;
      store.dispatch(setPersonalizedValues({ name: 'startDate', value: null }));
      store.dispatch(setPersonalizedValues({ name: 'endDate', value: null }));
    }
  } else {
    // No date params - clear date state
    dates = null;
    store.dispatch(setPersonalizedValues({ name: 'startDate', value: null }));
    store.dispatch(setPersonalizedValues({ name: 'endDate', value: null }));
  }

  // Default Map Show
  await store.dispatch(setPersonalizedValues({ name: 'showMap', value: true }));

  await store.dispatch(searchListing({ personCapacity, dates, currentPage, location }))

  return {
    title,
    component: <FooterLessLayout page={'search'} fixedHeader={fixedHeader}><Search
      initialFilter={initialFilter}
      searchSettings={data.getSearchSettings}
    />
    </FooterLessLayout>,
  };
}
